var _g, _g2, _g3, _g4, _path, _path2, _g5, _g6, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgWeeklyreport = function SvgWeeklyreport(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 141,
    viewBox: "0 0 189 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_799_2091)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.23 35.266C163.563 35.266 167.887 31.1682 167.887 26.1133C167.887 21.0583 163.563 16.9605 158.23 16.9605C152.896 16.9605 148.573 21.0583 148.573 26.1133C148.573 31.1682 152.896 35.266 158.23 35.266Z",
    fill: "url(#paint0_linear_799_2091)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.865,
    y: 21.0289,
    width: 24,
    height: 24,
    fill: "url(#pattern0)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_799_2091)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2257 118.485C50.1305 118.485 54.9173 113.948 54.9173 108.351C54.9173 102.755 50.1305 98.218 44.2257 98.218C38.321 98.218 33.5342 102.755 33.5342 108.351C33.5342 113.948 38.321 118.485 44.2257 118.485Z",
    fill: "url(#paint1_linear_799_2091)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.1974 113.166C44.5567 113.476 45.0789 113.472 45.4339 113.157C46.8504 111.902 50.2228 108.706 50.2228 106.749C50.2228 105.464 49.4026 104.149 47.6174 104.149C46.17 104.149 44.819 105.844 44.819 105.844C44.819 105.844 43.4681 104.149 42.0207 104.149C40.2355 104.149 39.2705 105.474 39.2705 106.749C39.2705 108.71 42.7488 111.916 44.1974 113.166Z",
    stroke: "white",
    strokeWidth: 1.1
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_799_2091)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0059 63.1287C33.362 63.1287 39.3253 57.4767 39.3253 50.5047C39.3253 43.5326 33.362 37.8806 26.0059 37.8806C18.6498 37.8806 12.6865 43.5326 12.6865 50.5047C12.6865 57.4767 18.6498 63.1287 26.0059 63.1287Z",
    fill: "url(#paint2_linear_799_2091)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4937 56.6938C31.707 56.6938 31.8814 56.5206 31.8814 56.3089V55.3272C31.8814 53.7874 31.0479 52.363 29.7299 51.5931L29.6911 51.5738C27.2294 50.1495 24.1668 50.1495 21.7052 51.5738L21.6664 51.5931C20.3096 52.363 19.4761 53.8066 19.4761 55.3272V56.3089C19.4761 56.5206 19.6505 56.6938 19.8637 56.6938C20.077 56.6938 20.2514 56.5206 20.2514 56.3089V55.3272C20.2514 54.0761 20.9298 52.8827 22.0347 52.2668L22.0734 52.2475C24.3025 50.9579 27.055 50.9579 29.284 52.2475L29.3228 52.2668C30.4277 52.9019 31.1061 54.0761 31.1061 55.3272V56.3089C31.1061 56.5206 31.2805 56.6938 31.4937 56.6938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2236 48.4851C27.6991 49.3519 26.7278 49.8867 25.6788 49.8867C24.6299 49.8867 23.6586 49.3519 23.1341 48.5036C22.6096 47.6552 22.6096 46.5856 23.1341 45.7188C23.6586 44.8521 24.6299 44.3173 25.6788 44.3173C26.7278 44.3173 27.6991 44.8521 28.2236 45.7004C28.7481 46.5487 28.7481 47.6184 28.2236 48.4851ZM25.6788 45.0549C24.9212 45.0549 24.2025 45.4607 23.814 46.0877C23.4255 46.7147 23.4255 47.4893 23.814 48.1347C24.2025 48.7802 24.9212 49.1675 25.6788 49.1675C26.4364 49.1675 27.1552 48.7617 27.5437 48.1347C27.9322 47.5077 27.9322 46.7147 27.5437 46.0877C27.1552 45.4422 26.4364 45.0549 25.6788 45.0549Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_799_2091)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.7882 69.2389C86.8115 51.7714 34.4106 18.0571 24.6826 34.6021C14.9546 51.147 24.3069 82.1975 44.6932 90.1488C65.0796 98.1 88.7648 86.7065 87.7882 69.2389Z",
    fill: "#FF5E6D",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.9941 63.8718C77.2891 48.65 146.77 19.2704 159.669 33.6882C172.568 48.1059 169.303 78.4321 142.272 85.361C115.24 92.29 74.6992 79.0936 75.9941 63.8718Z",
    fill: "#FF5E6D",
    fillOpacity: 0.189658
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.942 24.3896C105.527 23.1213 106.671 21.4256 106.684 19.3011C106.723 13.1797 97.2011 12.8425 95.1117 15.5657C93.0224 18.2889 92.5828 26.0569 94.902 27.0202C95.8269 27.4043 97.8817 27.228 100.021 26.4888L98.0472 34.3741L105.628 35.7158L103.942 24.3896Z",
    fill: "#D7927E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.007 11.9027C100.966 11.9 103.519 12.1796 103.988 12.2493C104.287 12.2938 104.606 12.4053 104.809 12.1776C104.975 11.9911 104.957 11.6312 105.025 11.3961C105.103 11.123 105.202 10.8567 105.303 10.5912C105.587 9.83579 105.974 9.13424 106.48 8.49687C107.429 7.3011 108.731 6.44727 110.303 6.07155C112.039 5.65672 113.944 5.78569 115.727 6.18704C117.634 6.61651 119.315 7.46104 121.075 8.28216C122.752 9.06462 124.542 9.54061 126.377 9.55275C128.225 9.56502 129.693 8.85742 131.317 8.22004C132.98 7.5675 134.836 7.255 136.683 7.66468C138.407 8.04714 139.941 8.94714 141.288 10.0451C142.549 11.0723 143.558 12.2328 144.043 13.7272C144.565 15.3348 144.398 16.9895 143.158 18.1573C141.359 19.85 138.33 19.9067 135.856 19.4888C134.426 19.2471 133.042 18.7962 131.732 18.1554C129.986 17.3008 128.526 16.0752 126.918 15.0179C126.163 14.5217 125.375 14.0892 124.539 13.7378C123.728 13.3967 122.917 13.175 122.116 13.5278C121.269 13.901 120.505 14.2778 119.561 14.45C118.656 14.6152 117.712 14.6426 116.779 14.4972C114.965 14.2145 113.227 13.4261 111.499 12.8142C110.09 12.3152 108.58 11.8022 107.086 11.8586C106.463 11.8822 105.546 11.9857 105.266 12.54C108.922 13.715 109.957 18.1794 108.596 21.1416C107.861 22.7404 104.263 24.2023 103.029 23.1211C102.248 22.4361 102.83 21.7759 103.208 21.339C103.932 20.5025 104.267 19.3396 103.166 18.5186C102.215 17.8106 101.025 18.9798 101.005 18.9754C100.73 18.9142 98.4659 17.3111 97.0022 15.2453C95.3692 15.0929 95.2219 14.0672 95.6908 13.316C96.1597 12.5648 98.6823 11.9066 100.007 11.9027Z",
    fill: "#191847"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_799_2091)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.685 64.1888L86.5194 99.565L70.6512 129.473H67.2333L93.8207 64.1888L107.685 64.1888Z",
    fill: "#D7927E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.0597 124.683L68.4684 122.69C71.3562 114.059 74.8957 104.561 79.0867 94.1963C83.2778 83.8313 87.7788 73.8288 92.5898 64.1888H111.206C105.857 76.383 100.187 87.463 94.1947 97.4287C88.2025 107.394 81.8242 116.479 75.0597 124.683Z",
    fill: "#6B90D6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.077 64.1888C111.074 76.6203 114.927 92.5029 115.291 92.993C115.533 93.3198 124.26 96.2432 141.471 101.763L140.733 104.777C120.209 101.816 109.394 99.5192 108.289 97.8859C106.632 95.436 98.3576 76.0818 95.1527 64.1888H109.077Z",
    fill: "#D7927E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.42 99.1588L134.12 104.012C118.769 105.358 109.363 104.385 105.903 101.094C102.442 97.8028 98.4976 85.5011 94.0699 64.1888H111.822C114.627 81.6407 116.195 90.7329 116.527 91.4655C116.858 92.1981 123.156 94.7626 135.42 99.1588Z",
    fill: "#98B8F9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.642 100.51C141.533 100.345 142.186 100.3 142.6 100.373C143.105 100.463 143.825 100.679 144.763 101.019C144.659 101.606 143.723 106.876 141.956 116.829C140.528 116.999 139.839 116.631 139.888 115.727C139.937 114.823 139.97 114.07 139.987 113.469L138.023 105.538C137.985 105.386 138.078 105.231 138.23 105.193C138.233 105.193 138.235 105.192 138.238 105.191L139.465 104.923C139.992 104.171 140.301 103.539 140.392 103.027C140.466 102.611 140.4 102.006 140.195 101.213L140.195 101.213C140.116 100.908 140.299 100.598 140.602 100.519C140.615 100.515 140.629 100.512 140.642 100.51Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_799_2091)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.8901 50.3341L69.0724 48.58C66.5084 47.1491 64.1496 46.1805 61.996 45.674C61.39 45.6562 60.4259 45.8773 61.8621 47.0785C63.2983 48.2798 64.7556 49.6086 64.4997 50.2497C64.2438 50.8908 62.9082 50.6522 62.6869 51.6383C62.5394 52.2956 64.7071 52.4024 69.19 51.9587L79.5904 56.0956L81.8901 50.3341ZM122.155 53.3107L115.046 53.3375C122.841 70.9365 126.906 80.1511 127.239 80.9812C127.991 82.849 126.401 85.6936 125.721 87.2222C127.935 88.2162 127.699 84.5351 130.492 85.8387C133.042 87.0287 134.981 89.1847 137.926 87.3614C138.288 87.1372 138.685 86.2932 137.726 85.6336C135.338 83.9904 131.896 81.1145 131.43 80.1678C130.796 78.8769 127.704 69.9245 122.155 53.3107Z",
    fill: "#D7927E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.684 30.6909L97.118 31.0629C95.7473 43.5052 88.2807 51.3643 71.5636 48.7037L69.3427 64.7266C84.9673 66.7525 98.6702 60.4765 101.479 43.4841C102.206 39.0853 102.78 34.5075 102.684 30.6909Z",
    fill: "#0C152F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.43 29.0673L96.9969 31.0051C96.9969 45.5572 92.3766 54.8418 90.0067 65.541H112.782C113.103 69.2381 113.3 73.0379 113.403 76.9407H130.456C126.592 56.3119 118.435 40.3523 105.987 29.0621H105.434L105.43 29.0673Z",
    fill: "#0C152F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.188 44.7806C109.775 53.8487 109.43 60.7689 108.153 65.5413H112.782C112.146 58.2175 111.025 51.2972 109.188 44.7806V44.7806Z",
    fill: "black",
    fillOpacity: 0.1
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.7412 128.091C73.0599 128.942 73.2192 129.578 73.2192 130C73.2192 130.514 73.1337 131.263 72.9625 132.248C72.3667 132.248 67.0114 132.248 56.8968 132.248C56.4794 130.869 56.7204 130.124 57.6198 130.014C58.5193 129.904 59.2666 129.804 59.8615 129.716L67.3287 126.388C67.4724 126.324 67.6408 126.388 67.7048 126.532C67.7059 126.534 67.707 126.537 67.708 126.539L68.188 127.703C69.0207 128.092 69.6973 128.286 70.2179 128.286C70.6409 128.286 71.2251 128.115 71.9703 127.773C72.2564 127.642 72.5945 127.768 72.7256 128.054C72.7313 128.066 72.7365 128.079 72.7412 128.091Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_799_2091",
    x: 136.573,
    y: 13.9605,
    width: 52.2925,
    height: 52.0684,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.825549 0 0 0 0 0.161775 0 0 0 0 0.223617 0 0 0 0.341455 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_799_2091"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_799_2091",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_799_2091",
    transform: "scale(0.00416667)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_799_2091",
    x: 20.5342,
    y: 94.218,
    width: 47.3833,
    height: 46.2668,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.825549 0 0 0 0 0.161775 0 0 0 0 0.223617 0 0 0 0.341455 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_799_2091"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_799_2091",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_799_2091",
    x: 0.686523,
    y: 34.8806,
    width: 50.6387,
    height: 49.2481,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.825549 0 0 0 0 0.161775 0 0 0 0 0.223617 0 0 0 0.341455 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_799_2091"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_799_2091",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_799_2091",
    x1: 167.887,
    y1: 16.9605,
    x2: 148.573,
    y2: 16.9605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37405,
    stopColor: "#FF5E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746912,
    stopColor: "#FF4F7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_799_2091",
    x1: 54.9173,
    y1: 98.218,
    x2: 33.5342,
    y2: 98.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37405,
    stopColor: "#FF5E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746912,
    stopColor: "#FF4F7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_799_2091",
    x1: 39.3253,
    y1: 37.8806,
    x2: 12.6865,
    y2: 37.8806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37405,
    stopColor: "#FF5E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746912,
    stopColor: "#FF4F7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D90"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_799_2091"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 146.233,
    height: 79.1059,
    fill: "white",
    transform: "translate(20.9639 13.6917)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_799_2091"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88.3015,
    height: 68.0602,
    fill: "white",
    transform: "matrix(-1 0 0 1 145 64.1888)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_799_2091"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77.2638,
    height: 59.2782,
    fill: "white",
    transform: "matrix(-1 0 0 1 138.377 29.0621)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_799_2091",
    width: 240,
    height: 240,
    xlinkHref: "data:image/png;base64,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"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWeeklyreport);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Weeklyreport.59be4084bbca60a11924e2db3aa722eb.svg";